angular.module('unica_media_directory.archive_media_directory_controllers', [])

.controller('ArchiveMediaDirectoryBasicController',
	function(
		$rootScope, $scope
	) {

	$scope.forms = {};

	$scope.showDelete = true;
	console.log( sessionStorage.getItem('from_admin_archive') );
	if ( sessionStorage.getItem('from_admin_archive') ) {
		console.log( 'test' );
		sessionStorage.removeItem('from_admin_archive');
		sessionStorage.setItem('sub_from_admin_archive', true);
		$scope.showDelete = false;
	}

	console.log( $scope.showDelete );
});